const PageHeaderUserNotificationClose = ({id, clearNotification}) => {
  return (
    <button className='page-header__notification-cancel' onClick={() => clearNotification(id)}></button>
  )
}

export default PageHeaderUserNotificationClose;
